/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataConfigurationV1 } from './dataConfigurationV1';
import { PersonDataDocument } from './personDataDocument';
import { Person } from './person';


export interface PersonDataInfo { 
    person?: Person;
    personalDataEditable?: boolean;
    addressEditable?: boolean;
    identityDocumentInfoEditable?: boolean;
    contactInfoEditable?: boolean;
    documentCountryCodeEditable?: boolean;
    citizenshipHidden?: boolean;
    personalDataStep?: PersonDataInfo.PersonalDataStepEnum;
    addressDataStep?: PersonDataInfo.AddressDataStepEnum;
    identityDocumentDataStep?: PersonDataInfo.IdentityDocumentDataStepEnum;
    contactDataStep?: PersonDataInfo.ContactDataStepEnum;
    documentsDataStep?: PersonDataInfo.DocumentsDataStepEnum;
    documents?: Array<PersonDataDocument>;
    dataConfiguration?: DataConfigurationV1;
}
export namespace PersonDataInfo {
    export type PersonalDataStepEnum = 'NONE' | 'READ' | 'WRITE';
    export const PersonalDataStepEnum = {
        None: 'NONE' as PersonalDataStepEnum,
        Read: 'READ' as PersonalDataStepEnum,
        Write: 'WRITE' as PersonalDataStepEnum
    };
    export type AddressDataStepEnum = 'NONE' | 'READ' | 'WRITE';
    export const AddressDataStepEnum = {
        None: 'NONE' as AddressDataStepEnum,
        Read: 'READ' as AddressDataStepEnum,
        Write: 'WRITE' as AddressDataStepEnum
    };
    export type IdentityDocumentDataStepEnum = 'NONE' | 'READ' | 'WRITE';
    export const IdentityDocumentDataStepEnum = {
        None: 'NONE' as IdentityDocumentDataStepEnum,
        Read: 'READ' as IdentityDocumentDataStepEnum,
        Write: 'WRITE' as IdentityDocumentDataStepEnum
    };
    export type ContactDataStepEnum = 'NONE' | 'READ' | 'WRITE';
    export const ContactDataStepEnum = {
        None: 'NONE' as ContactDataStepEnum,
        Read: 'READ' as ContactDataStepEnum,
        Write: 'WRITE' as ContactDataStepEnum
    };
    export type DocumentsDataStepEnum = 'NONE' | 'READ' | 'WRITE';
    export const DocumentsDataStepEnum = {
        None: 'NONE' as DocumentsDataStepEnum,
        Read: 'READ' as DocumentsDataStepEnum,
        Write: 'WRITE' as DocumentsDataStepEnum
    };
}


